
// Click sur le bouton de suppression d'un contact
$('a.delete_contact').click(function(evt) {
    var href = this.getAttribute('href');
    evt.preventDefault();
    var callBackOui = function() {
        window.location = href;
    };
    modalOuiNon('Êtes vous sur de vouloir supprimer ce candidat, ainsi que son dossier ?', null, callBackOui);
});
